import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/plots";
import { isEmpty, map } from "lodash";
import queryKeys from "common/queryKey";
import moment from "moment";
import { useFetch } from "hooks/useFetch";
import { connect } from "react-redux";
import { getClientid, getlevelList } from "redux/selectors";
import { Spin } from "antd";
import DetailsModal from "organisms/DetailsModal";

function AttritionbyDepartment({ value, clientid, levelList }) {
  const [dataList, setDataList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [plotData, setPlotData] = useState("");

  const { getAttritionByDepartment } = queryKeys;

  const payload = {
    method: "getLevel4Data",

  };

  const payloadString = JSON.stringify(payload);
  const { key, url } = getAttritionByDepartment(clientid, payloadString);

  const { data, isLoading, refetch } = useFetch(
    key,
    url,
    { enabled: !!clientid },
    payload
  );

  console.log("Attrition by Department data:", data);

  useEffect(() => {
    // API response: { response: { attritionByDepartment: [{ name, userCount }] } }
    const response = data?.response?.departmentData;
    if (!isEmpty(response)) {
      dataTranformation(response);
    }
  }, [data]);

  // Maps { name, userCount } -> chart's expected { Department, Count, list }
  function dataTranformation(attritionData) {
    const result = map(attritionData, (item) => ({
      Department: item.name,
      Count: item.userCount ?? 0,
      list: [],
    }));

    setDataList(result);
  }

  const plotClick = () => {
    if (plotData?.data?.data) {
      setTableData(plotData?.data?.data?.list);
      setIsModalVisible(true);
    }
  };

  useEffect(() => {
    if (plotData !== "") {
      plotClick();
    }
  }, [plotData]);

  const config = {
    data: dataList,
    xField: "Department",
    yField: "Count",
    color: "#9CD3FA",
    animation: false,
    onReady: (plot) => {
      plot.on("plot:click", (evt) => {
        setPlotData(evt);
      });
    },
    label: {
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
    xAxis: {
      label: { autoHide: true, autoRotate: true },
    },
    yAxis: {
      tickInterval: 4,
      title: {
        text: "Head Count",
        style: { fontSize: 12, fontWeight: 500 },
      },
      grid: { line: { style: { opacity: 0 } } },
    },
  };

  return (
    <>
      <h6 className="mt-2">Attrition by Department:</h6>
      <div className="box-container">
        <Spin spinning={isLoading}>
          <Column {...config} />
        </Spin>
      </div>

      <DetailsModal
        isopen={isModalVisible}
        isCancel={() => setIsModalVisible(false)}
        tabledata={tableData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  clientid: getClientid(state),
  levelList: getlevelList(state),
});

export default connect(mapStateToProps, null)(AttritionbyDepartment);